var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTravel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,23.5l.5-6h2.5V14a5,5,0,0,0-10,0v3.5H3l.5,6Z",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 4,
    r: 3.5,
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13,.5h2.25A3.75,3.75,0,0,1,19,4.25V7",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "21.5 4.5 19 7 16.5 4.5",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,14.59c0,2.33-3.51,6.93-4.7,8.42a.49.49,0,0,1-.39.19A.51.51,0,0,1,18,23c-1.19-1.49-4.7-6.09-4.7-8.42a5.09,5.09,0,0,1,10.18,0Z",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.32,14.59a1.91,1.91,0,1,1-1.91-1.91A1.92,1.92,0,0,1,20.32,14.59Z",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.b7ffd073.svg";
export { ForwardRef as ReactComponent };